import css from 'styled-jsx/css';
import classnames from 'classnames';
import Downshift from 'downshift';
import { Label, Input, Error } from './FormControl';
import { colors } from '../Theme';

const styles = css`
  .country-selector__autosuggest {
    display: flex;
    flex-direction: column;
  }

  .country-selector__suggestions {
    margin: 0;
    padding: 0;
    list-style-type: none;
    flex-grow: 1;
    font-size: 1rem;
    flex-direction: column;
    box-sizing: border-box;
  }
  .country-selector__suggestions--open {
    display: flex;
    border-left: 2px solid ${colors.ywgVeryLightBlue};
    border-right: 2px solid ${colors.ywgVeryLightBlue};
    border-bottom: 2px solid ${colors.ywgVeryLightBlue};
  }
  .country-selector__suggestions--empty {
    display: none;
  }
  .country-selector__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }
  .country-selector__suggestion--highlighted {
    background-color: #ddd;
  }
`;

const inputStyles = css.resolve`
  .country-input {
    margin-bottom: 0;
    z-index: 10;
  }
`;

const getSuggestionValue = suggestion =>
  suggestion ? suggestion.label || '' : '';

const normalize = s =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
const filterCountries = (countries, inputValue) =>
  countries.filter(
    country =>
      !inputValue ||
      normalize(country.label).slice(0, inputValue.length) ===
        normalize(inputValue)
  );
const CountrySelector = ({
  label,
  name,
  className,
  value,
  autoComplete,
  valid,
  error,
  required,
  onChange,
  countries,
  autofocus,
  suggestionsClassName,
  inputClassName
}) => {
  return (
    <>
      <Downshift
        onChange={selection =>
          onChange({
            target: { name: name, value: selection ? selection.label : null }
          })
        }
        itemToString={getSuggestionValue}
        id={`${name}-suggest`}
        labelId={`${name}-label`}
        inputId={name}
        menuId={`${name}-menu`}
        initialInputValue={value}
      >
        {({
          getInputProps,
          getItemProps,
          getLabelProps,
          getMenuProps,
          isOpen,
          inputValue,
          highlightedIndex,
          selectedItem,
          selectItem,
          clearSelection
        }) => {
          const suggestions = filterCountries(countries, inputValue);
          const onInputBlur = e => {
            const label = e.target.value;
            if (selectedItem) {
              if (selectedItem.label === label) {
                return;
              }
            }
            const matchingItem =
              countries.find(
                country => normalize(country.label) === normalize(label)
              ) || suggestions.length === 1
                ? suggestions[0]
                : null;
            if (matchingItem) {
              selectItem({
                label: matchingItem.label
              });
            } else {
              clearSelection();
            }
          };
          const inputProps = getInputProps({
            type: 'text',
            name: name,
            valid: valid,
            required: required,
            autoComplete: autoComplete || 'country-name',
            placeholder: '',
            onChange: e => {
              if (!e.target.value) {
                clearSelection();
              }
            },
            onBlur: onInputBlur,
            autoFocus: autofocus || false,
            className: classnames(
              inputStyles.className,
              'country-input',
              inputClassName
            )
          });
          return (
            <div
              className={classnames('country-selector__autosuggest', className)}
            >
              <Label {...getLabelProps({ required: required })}>{label}</Label>
              <Input {...inputProps} />
              <ul
                {...getMenuProps()}
                className={classnames(
                  'country-selector__suggestions',
                  suggestionsClassName,
                  {
                    'country-selector__suggestions--open': isOpen,
                    'country-selector__suggestions--empty':
                      suggestions.length === 0
                  }
                )}
              >
                {isOpen
                  ? suggestions.map((item, index) => (
                      <li
                        key={item.code}
                        {...getItemProps({
                          key: item.code,
                          index,
                          item
                        })}
                        className={classnames('country-selector__suggestion', {
                          'country-selector__suggestion--highlighted':
                            highlightedIndex === index,
                          'country-selector__suggestion--selected':
                            selectedItem === item
                        })}
                      >
                        {item.label}
                      </li>
                    ))
                  : null}
              </ul>
              <Error valid={valid} error={error} />
            </div>
          );
        }}
      </Downshift>
      <style jsx>{styles}</style>
      {inputStyles.styles}
    </>
  );
};
export default CountrySelector;
